import React, {useState} from 'react';
import SectionLayout from '../../../CommonComponents/Layout/sectionLayout';
import CommonAdsListingCard from '../CommonAdsListing/CommonAdsListingCard';
import {Button, Col, Row} from 'antd';
import CommonHeroText from '../../../CommonComponents/CommonHeroText';
import useLocalization from '../../../../Localization';
import AdsFormComponent from '../AdsForm';
import {PlusOutlined} from '@ant-design/icons';
import {getLocalStorageUserInfo} from '../../../../Util/commonUtility';
import {useNavigate} from 'react-router-dom';

const ApprovedAdsListing = ({
  allApprovedAdsData,
  adFeesOptions,
  zeroFeeData,
}) => {
  const {ApplicationString} = useLocalization();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();

  const handleModalOpen = () => {
    const userInfo = getLocalStorageUserInfo();
    if (!userInfo) {
      navigate('/login');
      localStorage.setItem('redirectUrl', '/ads');
      return;
    }
    setIsModalOpen(true);
  };

  return (
    <React.Fragment>
      <Row gutter={[0, 30]} className='pbssMainContainerRowJobsListingPage'>
        <Col span={24}>
          <CommonHeroText
            heading={
              ApplicationString['userApprovedAdsListingComponent.heading']
            }
            subheading={''}
          />
        </Col>
        <Col span={24}>
          <SectionLayout>
            <span className='jobListingPageContentHeading'>
              {ApplicationString['userApprovedAdsListingComponent.subheading']}
            </span>
          </SectionLayout>
        </Col>
        <Col span={24}>
          <SectionLayout>
            <div>
              <Button
                type='primary'
                id='UserJobsComponent-filterButton-addJobs'
                prefixCls='add-new-listing-button'
                onClick={handleModalOpen}>
                <span className='add-new-listing-button-content'>
                  {
                    ApplicationString[
                      'userComponent.button.addListing.approvedAds'
                    ]
                  }{' '}
                </span>
                <div>
                  <PlusOutlined className='add-new-listing-icon' />
                </div>
              </Button>
            </div>
          </SectionLayout>
        </Col>
        {
          <AdsFormComponent
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
            adFeesOptions={adFeesOptions}
            zeroFeeData={zeroFeeData}
          />
        }
        <Col span={24}>
          <SectionLayout>
            <div className='common-jobs-listing-main-container'>
              {allApprovedAdsData.map((item, index) => {
                return (
                  <CommonAdsListingCard
                    key={item?.id}
                    id={item?.id}
                    adsHeading={item?.vendor}
                    adsDescription={item?.description}
                    adsStatus={item?.status}
                    adsLogo={item?.logo_ids[0]}
                    url={item?.attachment_url}
                    approved_date={item?.approved_date}
                    showDeactivateButton={false}
                  />
                );
              })}
            </div>
          </SectionLayout>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default ApprovedAdsListing;
